import { SERVER_URL } from "../../utils/constants";
import HttpRequest from "../../utils/HttpRequest";

//event
export const getAllEventService = async (
  query
) => {
  return HttpRequest.get(`${SERVER_URL}/event/allevents${query || "?"}`);
};

export const getOneEventService = async (itemId) => {
  return HttpRequest.get(`${SERVER_URL}/event/one/${itemId}`);
};

export const updateEventService = async (itemId, data) => {
  return HttpRequest.update(`${SERVER_URL}/event/one/${itemId}`, data);
};

//booking
export const addBookingService = async (
  data
) => {
  return HttpRequest.post(`${SERVER_URL}/booking/book-ticket`, data);
};

export const getOneBookingService = async (itemId) => {
  return HttpRequest.get(`${SERVER_URL}/booking/one/${itemId}`);
};

//Payment
export const confirmPaymentService = async (
  data
) => {
  return HttpRequest.post(`${SERVER_URL}/payment/confirm-payment`, data);
};

export const getOneInvoiceService = async (itemId) => {
  return HttpRequest.get(`${SERVER_URL}/payment/one/${itemId}`);
};